import React from "react"

import Card from "components/Card"
import Content from "../content/Content"

import styles from "./PostComplete.css"
import { getDirection } from "core/useDirectionality"



const ConclusionContentCard = ({ post, language, title }) => {
  return (
    <Card className={styles.main_article}>
      <Content title={title} data={post} dir={getDirection(language)} />
    </Card>
  )
}
export default ConclusionContentCard
